import { makeGraphqlRequestCloud } from 'api/graphql/graphQLClient';
import { ValidatePostprocessing } from '@/graphql/cloud/postprocessings/mutations/ValidatePostprocessing.graphql';

export const apiPostprocessing = {
  validate(postprocessing) {
    return makeGraphqlRequestCloud(ValidatePostprocessing, { postprocessing });
  },
};
